// extracted by mini-css-extract-plugin
export default {"edit":"Vacantion_edit__b46sz","table":"Vacantion_table__uEcvc"};